import React, { Suspense } from 'react';
import TeacherIncidentReport from './TeacherIncidentReport';

const IncidentReportConfig = {
	settings: {
		layout: {
			config: {
				navbar: {
					display: false,
				},
				toolbar: {
					display: false,
				},
				footer: {
					display: false,
				},
			},
		},
	},
	routes: [
		{
			path: '/teacher/incident-report',
			element: (
				<Suspense fallback={<>...</>}>
					<TeacherIncidentReport />
				</Suspense>
			),
		},
	],
	auth: null,
};

export default IncidentReportConfig;
